import { Currency, Locale } from '@synergy/models';
import { unique } from '@synergy/utils';

import { WishList, WishListItemStatus, WishListSupplier } from '../wish-list';
import { WishListDto } from '../dto/wish-list-dto';
import { WishListListItem } from '../wish-list-list-item';
import { mapWishListSupplier } from './wish-list-supplier-mapper';

export const mapWishList = (
    wishList: WishListDto,
    locales: Locale[],
    currency: Currency,
    wishLists: WishListListItem[],
    contactId?: number
): WishList | null => {
    const suppliers = wishList.suppliers.map(supplier => mapWishListSupplier(supplier, locales, currency));

    if (suppliers.some(supplier => supplier === null)) {
        return null;
    }

    return {
        id: wishList.id,
        suppliers: suppliers as WishListSupplier[],
        updatedAt: wishList.updatedAt ?? wishList.createdAt ?? null,
        itemStatuses: unique(suppliers.map(supplier => supplier?.items.map(item => item.status)).flat()).filter(
            (x): x is WishListItemStatus => x !== null
        ),
        name: wishList.name,
        sharedAccounts: wishList.sharedAccounts,
        customerAccount: wishList.customerAccount,
        isSharedWithOwnAccounts: wishList.isSharedWithOwnAccounts,
        isSharedWithOtherAccountUsers: wishList.isSharedWithOtherAccountUsers,
        type: wishList.type,
        isOwner: contactId === wishLists.find(w => w.id === wishList.id)?.owner?.id,
        infoText: wishList.infoText ?? '',
    };
};
